import * as S from './styles';

interface Props {
  userName: string;
}

export function HomePageBanner ({ userName }: Props) {
  return (
    <S.Container>
      <S.TitleContainer>
        <S.Title fontWeight={400}>Olá </S.Title>
        <S.Title fontWeight={700}>{userName}!</S.Title>
      </S.TitleContainer>
    </S.Container>
  )
}
